import { render, staticRenderFns } from "./screen-animations.vue?vue&type=template&id=060bfc67"
import script from "./screen-animations.vue?vue&type=script&lang=ts"
export * from "./screen-animations.vue?vue&type=script&lang=ts"
import style0 from "./screen-animations.vue?vue&type=style&index=0&id=060bfc67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports